document.addEventListener( 'DOMContentLoaded', function () {
	const priceOptionHeaderEls = document.querySelectorAll(
		'.wp-block-wpsp-pricing-table-price-option-header'
	);

	// Move special classes to wrapper.
	priceOptionHeaderEls.forEach( function ( el ) {
		if ( el.classList.contains( 'is-disabled' ) ) {
			el.parentElement.classList.add( 'is-disabled' );
		}

		if ( el.classList.contains( 'is-featured' ) ) {
			el.parentElement.classList.add( 'is-featured' );
		}

		if ( el.classList.contains( 'is-style-small' ) ) {
			el.parentElement.classList.add( 'is-style-small' );
		}
	} );
} );
